// extracted by mini-css-extract-plugin
export default {"container":"forum__container___GOWay","bg-red":"forum__bg-red___FMJ8t","bg-green":"forum__bg-green____5G2O"};